export default "__VITE_ASSET__CHrpJTu0__"